import type { AppConfig } from '#/config/types/AppConfig';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiUserEnvironment } from './types/ApiUserEnvironment';

type ApiResponse = ApiUserEnvironment & {
  config: AppConfig;
};

function mapResponse(response: ApiResponse) {
  return {
    user: response.user,
    environment: response.environment,
    appConfig: response.config,
  };
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/data/environment',
  mapResponse,
});

// Exports

export const apiFetchUserEnvironment = endpoint.client();

export const apiServerFetchUserEnvironment = endpoint.server();
